var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"codeBrowser"},[_vm._l((_vm.codes),function(code,key){return _c('div',{key:key,staticClass:"codeBrowser__code",class:code.redeemed && !code.unlimited ? '-redeemed' : null},[_vm._v("\n        "+_vm._s(code.code)+"\n    ")])}),_vm._v(" "),(_vm.moreCodes)?_c('div',[_vm._v(" ("+_vm._s(_vm.moreCodes)+" more codes...)")]):_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a630d2b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/CodeBrowser.vue
// module id = pxlZ
// module chunks = 0